const getActiveBackend = (state) => state.activeBackend;
const getActiveBackendName = (state) => state.activeBackendName;
const getValidBackend = (state) => state.validBackend;
const getBackendConfig = (state) => state.backendConfig;

export {
  getActiveBackend,
  getActiveBackendName,
  getValidBackend,
  getBackendConfig,
};
